import { InnerQueryExpression } from "./InnerQueryExpression";

export class SelectClause {
    public readonly name: string;
    public readonly expression: InnerQueryExpression;

    public constructor(name: string, expression: InnerQueryExpression) {
        this.name = name;
        this.expression = expression;
    }
}
